

// import React, { useEffect } from "react";
// import {
//   PiSquaresFourBold,
//   PiFileTextBold,
//   PiFolderOpenBold,
//   PiChatCircleTextBold,
//   PiGearBold,
//   PiSignOutBold,
//   PiListBold,
//   PiXBold
// } from "react-icons/pi";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../contexts/AuthContext";
// import logo from "../assets/logo.png";
// import "./Sidebar.css";

// function Sidebar({ isMobileMenuOpen, setIsMobileMenuOpen, isCollapsed, toggleSidebar }) {
//   const { logout } = useAuth();
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Close mobile menu automatically on route change
//   useEffect(() => {
//     if (window.innerWidth <= 768) {
//       setIsMobileMenuOpen(false);
//     }
//   }, [location, setIsMobileMenuOpen]);

//   const isActive = (path) => location.pathname === path;

//   // Handle Menu Toggle (Close on mobile, Collapse on desktop)
//   const handleToggle = () => {
//     if (window.innerWidth <= 768) {
//       setIsMobileMenuOpen(false);
//     } else {
//       toggleSidebar();
//     }
//   };

//   const handleNavigation = (path) => {
//     navigate(path);
//   };

//   // LOGIC FIX: If mobile menu is open, force the sidebar to be fully expanded.
//   // We only apply the 'collapsed' class if we are NOT in mobile mode.
//   const sidebarClasses = `sidebar ${ isMobileMenuOpen ? "mobile-open" : (isCollapsed ? "collapsed" : "") }`;

//   return (
//     <>
//       {/* Mobile Overlay - Clicking this closes the menu */}
//       <div
//         className={`mobile-overlay ${ isMobileMenuOpen ? "active" : "" }`}
//         onClick={() => setIsMobileMenuOpen(false)}
//       />

//       <nav className={sidebarClasses}>
//         <div className="sidebar-header">
//           {/* Force Logo to show if mobile menu is open */}
//           {(isMobileMenuOpen || !isCollapsed) && (
//             <div className="logo-section">
//               <img src={logo} alt="Moonshot" className="logo-img" />
//               <span className="logo-Text">MoonShotMap</span>
//             </div>
//           )}

//           <button
//             className="menu-toggle-btn"
//             onClick={handleToggle}
//             aria-label="Toggle Menu"
//           >
//             {isMobileMenuOpen ? <PiXBold /> : <PiListBold />}
//           </button>
//         </div>

//         <div className="sidebar-content">
//           <ul className="sidebar-menu">
//             <SidebarItem
//               icon={<PiSquaresFourBold />}
//               label="Dashboard"
//               active={isActive("/mainPage") || isActive("/")}
//               onClick={() => handleNavigation("/mainPage")}
//               collapsed={!isMobileMenuOpen && isCollapsed}
//             />
//             <SidebarItem
//               icon={<PiFileTextBold />}
//               label="Fog Index"
//               active={isActive("/fogindex")}
//               onClick={() => handleNavigation("/fogindex")}
//               collapsed={!isMobileMenuOpen && isCollapsed}
//             />
//             <SidebarItem
//               icon={<PiFolderOpenBold />}
//               label="Reality Check"
//               active={isActive("/realitycheck")}
//               onClick={() => handleNavigation("/realitycheck")}
//               collapsed={!isMobileMenuOpen && isCollapsed}
//             />
//             <SidebarItem
//               icon={<PiChatCircleTextBold />}
//               label="Clarity Check"
//               active={isActive("/claritycheck")}
//               onClick={() => handleNavigation("/claritycheck")}
//               collapsed={!isMobileMenuOpen && isCollapsed}
//             />
//           </ul>

//           <div className="sidebar-bottom">
//             <ul className="sidebar-menu">

//               <li
//                 className="menu-item logout"
//                 onClick={logout}
//                 title={(!isMobileMenuOpen && isCollapsed) ? "Logout" : ""}
//               >
//                 <div className="icon-box"><PiSignOutBold /></div>
//                 {/* Always show label if mobile menu is open, otherwise check collapsed state */}
//                 {(isMobileMenuOpen || !isCollapsed) && <span className="item-label">Logout</span>}
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>
//     </>
//   );
// }

// const SidebarItem = ({ icon, label, active, onClick, collapsed }) => (
//   <li
//     className={`menu-item ${ active ? "active" : "" }`}
//     onClick={onClick}
//     title={collapsed ? label : ""}
//   >
//     <div className="icon-box">{icon}</div>
//     {/* Only hide label if strictly collapsed (and not in mobile mode) */}
//     {!collapsed && <span className="item-label">{label}</span>}
//   </li>
// );

// export default Sidebar;

import React, { useEffect, useState } from "react";
import {
  PiSquaresFourBold,
  PiFileTextBold,
  PiFolderOpenBold,
  PiChatCircleTextBold,
  PiSignOutBold,
  PiListBold,
  PiXBold,
  PiVaultBold,
  PiMapTrifoldBold,
  PiPlusBold,          // New
  // PiChatCircleBold,    // Removed unused
  PiNotePencilBold     // New
} from "react-icons/pi";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import logo from "../assets/logo.png";
import "./Sidebar.css";


function Sidebar({ isMobileMenuOpen, setIsMobileMenuOpen, isCollapsed, toggleSidebar }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [miniShots, setMiniShots] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // -- 1. CHECK CHAT MODE --
  const isChatMode = (location.pathname.startsWith("/moonshot") && !location.pathname.startsWith("/moonshot-map")) ||
    location.pathname.startsWith("/minishot") ||
    (location.pathname === "/moonshot-map" && new URLSearchParams(location.search).has("projectId"));

  // -- 2. FETCH CHATS --
  useEffect(() => {
    // Only fetch if we are in chat mode (optimization)
    if (!isChatMode) return;

    const fetchMiniShots = async () => {
      try {
        const res = await fetch(`${ API_BASE_URL }/api/minishots`, {
          credentials: "include",
        });
        if (res.ok) {
          const data = await res.json();
          // Sort: Newest first
          const sorted = (data.miniShots || []).sort((a, b) =>
            new Date(b.lastMessageAt || b.createdAt) - new Date(a.lastMessageAt || a.createdAt)
          );
          setMiniShots(sorted);
        }
      } catch (err) {
        console.error("Error loading sidebar chats:", err);
      }
    };
    fetchMiniShots();
  }, [location.pathname, isChatMode, API_BASE_URL]); // Reload when path changes (e.g. creating new chat)

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setIsMobileMenuOpen(false);
    }
  }, [location, setIsMobileMenuOpen]);

  const isActive = (path) => location.pathname === path;
  const isChatActive = (id) => location.pathname === `/minishot/${ id }`;

  const handleToggle = () => {
    if (window.innerWidth <= 768) {
      setIsMobileMenuOpen(false);
    } else {
      toggleSidebar();
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const sidebarClasses = `sidebar ${ isMobileMenuOpen ? "mobile-open" : (isCollapsed ? "collapsed" : "") }`;

  // --- RENDER HELPERS ---

  const renderStandardMenu = () => (
    <div className="sidebar-content">
      <ul className="sidebar-menu">
        <SidebarItem
          icon={<PiSquaresFourBold />}
          label="Dashboard"
          active={isActive("/mainPage") || isActive("/")}
          onClick={() => handleNavigation("/mainPage")}
          collapsed={!isMobileMenuOpen && isCollapsed}
        />
        <SidebarItem
          icon={<PiFileTextBold />}
          label="Fog Index"
          active={isActive("/fogindex")}
          onClick={() => handleNavigation("/fogindex")}
          collapsed={!isMobileMenuOpen && isCollapsed}
        />
        <SidebarItem
          icon={<PiFolderOpenBold />}
          label="Reality Check"
          active={isActive("/realitycheck")}
          onClick={() => handleNavigation("/realitycheck")}
          collapsed={!isMobileMenuOpen && isCollapsed}
        />
        <SidebarItem
          icon={<PiChatCircleTextBold />}
          label="Clarity Check"
          active={isActive("/claritycheck")}
          onClick={() => handleNavigation("/claritycheck")}
          collapsed={!isMobileMenuOpen && isCollapsed}
        />
        <SidebarItem
          icon={<PiMapTrifoldBold />}
          label="Moonshot Map"
          active={isActive("/moonshot-map")}
          onClick={() => handleNavigation("/moonshot-map")}
          collapsed={!isMobileMenuOpen && isCollapsed}
        />
        <SidebarItem
          icon={<PiVaultBold />}
          label="Data Room"
          active={isActive("/dataroom")}
          onClick={() => handleNavigation("/dataroom")}
          collapsed={!isMobileMenuOpen && isCollapsed}
        />
      </ul>

      <div className="sidebar-bottom">
        <ul className="sidebar-menu">
          <li
            className="menu-item logout"
            onClick={logout}
            title={(!isMobileMenuOpen && isCollapsed) ? "Logout" : ""}
          >
            <div className="icon-box"><PiSignOutBold /></div>
            {(isMobileMenuOpen || !isCollapsed) && <span className="item-label">Logout</span>}
          </li>
        </ul>
      </div>
    </div>
  );

  const renderChatSidebar = () => (
    <div className="sidebar-content chat-mode">
      {/* New Chat Button */}
      <div className="new-chat-section">
        <button
          className={`new-chat-btn ${ isActive("/moonshot") ? "active-new-chat" : "" }`}
          onClick={() => handleNavigation("/moonshot")}
          title={isCollapsed ? "New Moonshot" : ""}
        >
          <div className="icon-box"><PiPlusBold /></div>
          {(!isCollapsed || isMobileMenuOpen) && <span className="item-label">New Moonshot</span>}
          {(!isCollapsed || isMobileMenuOpen) && <span className="new-chat-shortcut"><PiNotePencilBold /></span>}
        </button>
      </div>

      {/* Scrollable List - HIDDEN when collapsed */}
      {(!isCollapsed || isMobileMenuOpen) && (
        <div className="chat-history-list">
          <div className="list-header">Your Moonshots</div>
          <ul className="sidebar-menu">
            {miniShots.length === 0 ? (
              <div className="empty-history">No history yet.</div>
            ) : (
              miniShots.map((ms) => (
                <SidebarItem
                  key={ms.id || ms._id}
                  label={ms.title || "Untitled Moonshot"}
                  active={isChatActive(ms.id || ms._id)}
                  onClick={() => {
                    const pId = ms.id || ms._id;
                    if (location.pathname === "/moonshot-map") {
                      handleNavigation(`/moonshot-map?projectId=${ pId }`);
                    } else {
                      handleNavigation(`/minishot/${ pId }`);
                    }
                  }}
                  collapsed={false} // Always expanded if visible
                  isHistoryItem={true}
                />
              ))
            )}
          </ul>
        </div>
      )}

      {/* Bottom: Back to Dashboard + Logout */}
      <div className="sidebar-bottom">
        <ul className="sidebar-menu">
          <SidebarItem
            icon={<PiSquaresFourBold />}
            label="Back to Dashboard"
            onClick={() => handleNavigation("/mainPage")}
            collapsed={!isMobileMenuOpen && isCollapsed}
          />
          <li
            className="menu-item logout"
            onClick={logout}
            title={(!isMobileMenuOpen && isCollapsed) ? "Logout" : ""}
          >
            <div className="icon-box"><PiSignOutBold /></div>
            {(isMobileMenuOpen || !isCollapsed) && <span className="item-label">Logout</span>}
          </li>
        </ul>
      </div>
    </div>
  );

  return (
    <>
      <div
        className={`mobile-overlay ${ isMobileMenuOpen ? "active" : "" }`}
        onClick={() => setIsMobileMenuOpen(false)}
      />

      <nav className={sidebarClasses}>
        <div className="sidebar-header">
          {(isMobileMenuOpen || !isCollapsed) && (
            <div className="logo-section" onClick={() => handleNavigation("/mainPage")} style={{ cursor: 'pointer' }}>
              <img src={logo} alt="Moonshot" className="logo-img" />
              <span className="logo-Text">MoonShotMap</span>
            </div>
          )}

          <button
            className="menu-toggle-btn"
            onClick={handleToggle}
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? <PiXBold /> : <PiListBold />}
          </button>
        </div>

        {isChatMode ? renderChatSidebar() : renderStandardMenu()}
      </nav>
    </>
  );
}

const SidebarItem = ({ icon, label, active, onClick, collapsed }) => (
  <li
    className={`menu-item ${ active ? "active" : "" }`}
    onClick={onClick}
    title={collapsed ? label : ""}
  >
    {icon && <div className="icon-box">{icon}</div>}
    {!collapsed && <span className="item-label">{label}</span>}
  </li>
);

export default Sidebar;